// extracted by mini-css-extract-plugin
export default {"wrapper":"G2-z","play":"H2-z"};